import { Component, Input } from '@angular/core';
import { BaseModal } from '@ui-app/modals/base-modal';

@Component({
  selector: 'badge-type-selection-modal',
  templateUrl: './badge-type-selection-modal.component.html',
  styleUrls: ['./badge-type-selection-modal.component.less']
})
export class BadgeTypeSelectionModalComponent extends BaseModal {
  @Input() categoryId: number;
  hovered: string = '';
  selected: string = 'initial'; // Default selection

  constructor() {
    super();
  }

  onHover(type: string) {
    this.hovered = type;
    this.selected = type; // Change selection on hover
  }

  onSelect(type: string) {
    this.action(type); // This will close the modal and return the value
  }

  onClose() {
    this.action(null); // This will close the modal without returning a value
  }
}